<template>
  <div class="page">
    <div class="header">
      <div class="nav">
        <div class="nav_content">开通会员</div>
      </div>
      <div class="nav-left" @click="goBack"><img src="../../assets/new/left.svg" alt="" /></div>
      <div class="vipInfo">
        <div class="avater">
          <img :src="vipInfo.photo" alt="" v-if="vipInfo.photo != '' && vipInfo.photo != null" />
          <img src="../../assets/new/avater.png" alt="" v-else />
        </div>
        <div class="tilte_2">
          <div class="name">{{ vipInfo.userName || '' }}</div>
          <div class="text_2" v-if="!showVip">你还不是会员，开通会员尊享各项权益</div>
          <div class="text_2" v-if="showVip">会员有限期至{{ vipInfo.memberTime || '' }}</div>
        </div>
        <div class="icon_3"><img src="../../assets/new/vip.svg" alt="" /></div>
      </div>
    </div>
    <div class="box_1">
      <div class="title_3">年度会员权益</div>
      <div class="box_2">
        <div class="icon_2"><img src="../../assets/new/Group 408.svg" alt="" /></div>
        <div class="text_4">
          <div>海量课程随心学，会员畅享零成本</div>
          <div class="text_5">海量课程免费观看</div>
        </div>
      </div>
      <div class="box_2">
        <div class="icon_2"><img src="../../assets/new/Group 409.svg" alt="" /></div>
        <div class="text_4">
          <div>无限次观看特权，想学就学无限制</div>
          <div class="text_5">不限观看次数</div>
        </div>
      </div>
      <div class="box_2">
        <div class="icon_2"><img src="../../assets/new/Group 411.svg" alt="" /></div>
        <div class="text_4">
          <div>全天候学习自由，时长无界尽情探索​</div>
          <div class="text_5">不限观看时长</div>
        </div>
      </div>
    </div>
    <div style="padding: 0 15px">
      <div class="box_3">
        <div class="text_6">{{ showVip ? '续费年度会员权益' : '开通年度会员权益' }} ¥{{ Number(vipInfo.memberPrice).toFixed(2) || 0 }}</div>
        <div class="btn_2" @click="openVip">立即{{ showVip ? '续费' : '开通' }}</div>
      </div>
      <div class="box_4" >
        <div class="icon_4" :class="{ active: agreedToTerms }" @click="toggleAgree"><img src="../../assets/new/gou.svg" alt="" /></div>
        <div @click.stop="xieyi">  <span>开通代表已阅读</span><span style="color: #4076f6">《会员服务协议》</span></div>
      
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { annualMember, toGenerateMemberOrder } from '../../api/vip';
import { Dialog } from 'vant';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      vipInfo: {},
      isMember: '',
      showVip: false,
      agreedToTerms: false //是否勾选协议
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    //获取会员信息
    getVipinfo() {
      annualMember().then(res => {
        this.vipInfo = res.data.data;
        this.isMember = res.data.data.isMember;
        if (this.isMember == '01') {
          this.showVip = false;
        } else {
          this.showVip = true;
        }
      });
    },
    //去会员协议
    xieyi(){
       this.$router.push({
              path: '/agreement',
            });
    },
    toggleAgree() {
      this.agreedToTerms = !this.agreedToTerms;
    },
    //开通会员
    openVip() {
      if (!this.agreedToTerms) {
        Dialog.alert({
          message: '请勾选《会员服务协议》',
          confirmButtonColor: '#2A70F2'
        }).then(() => {});
      } else {
        toGenerateMemberOrder({ equipment: '02' }).then(res => {
          if (res.data.data.result == 3) {
            this.$utils
              .showConfirm({
                title: '温馨提示',
                message: res.data.data.msg
              })
              .then(() => {
                this.$router.push('/myOrder');
              })
              .catch(() => {});
          } else if (res.data.data.result == 1) {
            let data = res.data.data.order;
            this.$router.push({
              path: '/payType',
              query: data
            });
          }
        });
      }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getVipinfo();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.page {
  background-color: #fff;
  // height: 100%;
  overflow-y: scroll;
}
.header {
  position: relative;
  width: 100%;
  height: 293px;
  background: linear-gradient(136deg, #0c112d 0%, #242d51 100%);
  border-radius: 0px 0px 0px 0px;
}
.nav {
  padding: 0 15px;
  height: 53px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.nav-left {
  position: absolute;
  top: 20px;
  left: 15px;
}
.nav_content {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 17px;
  color: #ffffff;
}
.vipInfo {
  display: flex;
  padding: 0 15px;
  margin-top: 17px;
}
.avater {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
}
.tilte_2 {
  margin-left: 8px;
  .name {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 15px;
    color: #ffffff;
    margin-bottom: 4px;
  }
  .text_2 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 11px;
    color: #ffffff;
  }
}
.icon_3 {
  width: 70px;
  margin-left: 18px;
  height: 50px;
  img {
    width: 70px;
    height: 50px;
  }
}
.box_1 {
  position: relative;
  top: -121px;
  left: 0;
  width: 100%;
  height: 455px;
  background: #ffffff;
  border-radius: 10px 10px 0px 0px;
  padding: 20px 15px;
  .title_3 {
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: bold;
    font-size: 16px;
    color: #1e325f;
  }
}
.box_2 {
  margin-top: 12px;
  display: flex;
  width: 100%;
  height: 72px;
  background: #f6f8fa;
  border-radius: 8px 8px 8px 8px;
  padding: 18px 15px;
  .icon_2 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: linear-gradient(180deg, #4076f6 0%, #9cb9ff 100%);
    border-radius: 8px 8px 8px 8px;
    img {
      width: 16px;
      height: 16px;
    }
  }
}
.text_4 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 14px;
  color: #333333;
  margin-left: 8px;
}
.text_5 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 11px;
  color: #667280;
  margin-top: 2px;
}
.box_3 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 15px;
  height: 56px;
  background: linear-gradient(97deg, #2a70f2 0%, #669cff 100%);
  border-radius: 8px 8px 8px 8px;
}
.text_6 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
}
.btn_2 {
  width: 72px;
  height: 32px;
  background: #ffffff;
  border-radius: 25px 25px 25px 25px;
  text-align: center;
  line-height: 32px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #4076f6;
}
.box_4 {
  margin-top: 8px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 11px;
  color: #666666;
  .icon_4 {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 1px solid #999999;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 6px;
      height: 4px;
    }
  }
}
.active {
  background: #4076f6;
  border: 0 !important;
}
</style>
